import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: true,
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
    'aria-busy': 'true',
  },
})
export class SpinnerComponent {
  @Input() title = 'Un momento, por favor';
  @Input() message = 'Te estamos conectando con tu cuenta Copec.';
}
